module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAG5JREFUOBFjYBgF5IbA////twIxOtiKbh4jugAhPshEbGoYgQBZnAmZQ002/QwG+pSoMCTkO5RwASkmFIaE5GEW0i8oYDZSSo+6GB6CdA2KbXBrEQzksoCQPELX0GMBc9MtUI6iErg19EKApi4GADz3jPtlRFoHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValighBottom_normal.png
// module id = 315
// module chunks = 0